import gql from 'graphql-tag';

export default gql`
  mutation findCreateManyTagMutation($names: [String!], $type: String!, $language: String) {
    findCreateManyTagMutation(names: $names, type: $type, language: $language) {
      tagIds
    }
  }
`;
